module.exports = __webpack_public_path__ + "img/comingSoon.dc8db841.png";